export default __webpack_public_path__ + "static/media/FAQ_12_2.90d7b015.png";